/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, Input } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
    selector: 'app-dialog-banner',
    template: `
        <div style="display: flex; align-items: center; width: 100%; min-height: 40px" class="primary-background-color">
            <div style="flex: 1; padding: 4px 10px">
                <h3 class="mat-h3" style="margin: 0">{{text}}</h3>
            </div>
            <ng-content></ng-content>
            @if (dialogRef) {
                <!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
                <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                <div style="padding-right: 8px; cursor: pointer" (click)="closeDialog()" matTooltip="Click to close" data-dialog-close>
                    <mat-icon style="color: white">close</mat-icon>
                </div>
            }
        </div>
    `,
    imports: [MatIconModule, MatTooltipModule]
})

export class DialogBannerComponent {
    @Input() text = "Dialog Heading";
    @Input() dialogRef : MatDialogRef<unknown>;
    @Input() dialogCloseValue: unknown;

    closeDialog() {
        this.dialogRef.close(this.dialogCloseValue ?? null);
    }
}
